if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.updateImage(opener);
      }

      updateImage(opener) {
        if (!opener) return;

        // Get the image to display
        const sourceImage = opener.tagName === 'IMG' ? opener : opener.querySelector('img');

        if (!sourceImage) return;

        const modalImageContainer = this.querySelector('.product-media-modal__image');
        if (!modalImageContainer) return;

        // Create new image with full size src
        const modalImage = document.createElement('img');
        modalImage.src = sourceImage.src;
        if (sourceImage.srcset) {
          modalImage.srcset = sourceImage.srcset;
        }

        // Clear and update modal image
        modalImageContainer.innerHTML = '';
        modalImageContainer.appendChild(modalImage);
      }
    }
  );
}
